import React from "react";
import classNames from "classnames";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { AddResourceIcon } from "./addResourceIcon";
import styles from "./styles.scss";

function Menu({ project }: Props) {
  const { pushView } = useModal();

  return (
    <div
      className={classNames(styles.addResourceButton)}
      onClick={() =>
        pushView({
          data: project,
          key: UseCases.addPlanzoneResourceToProject,
        })
      }
    >
      <AddResourceIcon className={styles.icon} />
    </div>
  );
}

export { Menu };
